import { Button, ButtonProps } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { useSearchParams } from 'react-router-dom'

/** 一点即开使用说明 */
const HelpDropdown = ({ children, onClick, ...rest }: ButtonProps) => {
  const [searchParams, setSearchParams] = useSearchParams()

  return (
    <Button
      type="text"
      aria-label="使用说明"
      icon={<QuestionCircleOutlined className="text-[18px]" />}
      {...rest}
      onClick={(e) => {
        searchParams.set('modal[help]', '1')
        setSearchParams(searchParams)
        onClick?.(e)
      }}
    >
      {children}
    </Button>
  )
}

export default HelpDropdown
